import {
    AccountSummaryType,
    RecentTransactionType,
    RECEIVE_ACCOUNTSUMMARY,
    REQUEST_ACCOUNTSUMMARY,
    RECEIVE_RECENTTRANSACTION,
    REQUEST_RECENTTRANSACTION,
    REQUEST_CHARTDATA,
    RECEIVE_CHARTDATA,
    IAccountSummaryResponse,
    IRecentTransactionResponse,
    TransactionChartType,
    ITransactionChartResponse,
} from "./types";
import { AppThunkAction } from "..";
import * as httpClient from "../../util/httpClient";

export const actionCreators = {
    requestAccountSummary: (): AppThunkAction<AccountSummaryType> => (dispatch, getState) => {
        let accountSummaryResponse: IAccountSummaryResponse;
        httpClient
            .sendRequest("GET", `api/financial-account/account-summary`)
            .then((data) => {
                dispatch({ type: RECEIVE_ACCOUNTSUMMARY, accountSummaryData: data });
            })
            .catch(function (error) {
                dispatch({ type: RECEIVE_ACCOUNTSUMMARY, accountSummaryData: accountSummaryResponse });
            });
        dispatch({ type: REQUEST_ACCOUNTSUMMARY });
    },
    requestMXAccountSummary: (): AppThunkAction<AccountSummaryType> => (dispatch, getState) => {
        let accountSummaryResponse: IAccountSummaryResponse;
        httpClient
            .sendRequest("GET", `api/mx/getUserData`)
            .then((data) => {
                setTimeout(() => {
                    httpClient
                        .sendRequest("GET", `api/financial-account/account-summary`)
                        .then((data) => {
                            dispatch({ type: RECEIVE_ACCOUNTSUMMARY, accountSummaryData: data });
                        })
                        .catch(function (error) {
                            dispatch({ type: RECEIVE_ACCOUNTSUMMARY, accountSummaryData: accountSummaryResponse });
                        });
                }, 12000);
            })
            .catch((error) => {
                setTimeout(() => {
                    httpClient
                        .sendRequest("GET", `api/financial-account/account-summary`)
                        .then((data) => {
                            dispatch({ type: RECEIVE_ACCOUNTSUMMARY, accountSummaryData: data });
                        })
                        .catch(function (error) {
                            dispatch({ type: RECEIVE_ACCOUNTSUMMARY, accountSummaryData: accountSummaryResponse });
                        });
                }, 12000);
            });
        dispatch({ type: REQUEST_ACCOUNTSUMMARY });
    },
    requestRecentTransactions:
        (offset: number, limit:string, bankAccountTypeId: string, startDate: string, endDate: string, accountId: string): AppThunkAction<RecentTransactionType> =>
        (dispatch, getState) => {
            let recentTransactionResponse: IRecentTransactionResponse;
            httpClient
                .sendRequest("POST", `api/financial-account/transaction-history`, {
                    offset: offset + "",
                    limit,
                    "bank-account-type-id": bankAccountTypeId,
                    "start-date": startDate,
                    "end-date": endDate,
                    "account-id": accountId,
                })
                .then((data) => {
                    dispatch({ type: RECEIVE_RECENTTRANSACTION, recentTransactionData: data });
                })
                .catch(function (error) {
                    dispatch({ type: RECEIVE_RECENTTRANSACTION, recentTransactionData: recentTransactionResponse });
                });
            dispatch({ type: REQUEST_RECENTTRANSACTION });
        },
    requestChartData: (): AppThunkAction<TransactionChartType> => (dispatch, getState) => {
        let transactionChartResponse: ITransactionChartResponse;
        httpClient
            .sendRequest("GET", `api/financial-account/stats`)
            .then((data) => {
                dispatch({ type: RECEIVE_CHARTDATA, transactionChartData: data });
            })
            .catch(function (error) {
                dispatch({ type: RECEIVE_CHARTDATA, transactionChartData: transactionChartResponse });
            });
        dispatch({ type: REQUEST_CHARTDATA });
    },
};
